import React from 'react';

import { LbInput } from '@infoods/lifebase-ui';

import { Control } from 'react-hook-form';
import classes from './CorporateAccountsModalForm.module.scss';
import { PasswordInput } from '../../../../../../../shared/components/form-components';
import { CorporateAccountFormValues } from '../../../../../../interfaces/CorporateAccount';

type CorporateAccountsModalFormProps = {
  control: Control<CorporateAccountFormValues, any, CorporateAccountFormValues>;
};

const CorporateAccountsModalForm = ({ control }: CorporateAccountsModalFormProps) => {
  return (
    <form className={classes.corporateAccountsModalForm}>
      <LbInput
        placeholder="Login"
        control={control}
        name="login"
        rules={{
          required: 'Login is required',
          minLength: { value: 5, message: 'Login must be at least 5 symbols' },
          maxLength: { value: 20, message: 'Login must be under 16 symbols' },
        }}
      />
      <PasswordInput label="Password" control={control} name="password" />
    </form>
  );
};

export { CorporateAccountsModalForm };
